module.exports = __webpack_public_path__ + "img/Ebond.111435a6.svg";